
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AsahiLogoNew',
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  }
})
